import defaultPreloader from 'assets/preloader/default.svg';

import { ConfigContext } from 'contexts/config';
import { useContext } from 'react';
import { ScPreloader } from './styled';

export const Preloader = () => {
  const { activeBrandAsset } = useContext(ConfigContext);

  const currentPreloader = activeBrandAsset?.preloader?.url || defaultPreloader;

  return (
    <ScPreloader>
      <div className="logo">
        <object
          aria-label="LuckyElf Casino"
          data={currentPreloader}
          height={57}
          width={200}
        />
      </div>
    </ScPreloader>
  );
};
